(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2492],{

/***/ 41127:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[slug]",
      function () {
        return __webpack_require__(68667);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 28032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ PreviewBadge; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97324);



function PreviewBadge(param) {
    let { isLive , isTop =false  } = param;
    if (!_utils__WEBPACK_IMPORTED_MODULE_1__/* .isProduction */ .yv && !isLive) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("mx-auto text-lg max-w-prose", isTop ? "mb-14" : "mt-14"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex justify-center w-full py-1 font-medium text-white uppercase bg-green-500",
                children: "Preview"
            })
        });
    }
    return null;
}


/***/ }),

/***/ 39309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Socials; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52494);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60239);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45501);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44587);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53140);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14823);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58038);





const { twitter , linkedin , facebook , discord , github  } = _lib__WEBPACK_IMPORTED_MODULE_2__/* .URLS */ .ns;
function Socials() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .HStack */ .Ug, {
        gap: "24px",
        display: "flex",
        w: "auto",
        justifyContent: {
            base: "space-between",
            md: "normal"
        },
        zIndex: 10,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                legacyBehavior: true,
                href: twitter,
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                    as: "a",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                        as: _components__WEBPACK_IMPORTED_MODULE_5__/* .TwitterIcon */ .Z,
                        h: "24px",
                        w: "24px",
                        color: "#949EB2"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                legacyBehavior: true,
                href: linkedin,
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                    as: "a",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                        as: _components__WEBPACK_IMPORTED_MODULE_6__/* .LinkedInIcon */ .n,
                        h: "24px",
                        w: "24px",
                        color: "#949EB2"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                legacyBehavior: true,
                href: github,
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                    as: "a",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                        as: _components__WEBPACK_IMPORTED_MODULE_7__/* .GitHubIcon */ .f,
                        h: "24px",
                        w: "24px",
                        color: "#949EB2"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                legacyBehavior: true,
                href: discord,
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                    as: "a",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                        as: _components__WEBPACK_IMPORTED_MODULE_8__/* .DiscordIcon */ .D,
                        h: "24px",
                        w: "24px",
                        color: "#949EB2"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                legacyBehavior: true,
                href: facebook,
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                    as: "a",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                        as: _components__WEBPACK_IMPORTED_MODULE_9__/* .FacebookIcon */ .V,
                        h: "24px",
                        w: "24px",
                        color: "#949EB2"
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 87585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pk": function() { return /* binding */ tutorialQuery; },
/* harmony export */   "Tc": function() { return /* binding */ docBySlugQuery; },
/* harmony export */   "Zk": function() { return /* binding */ blogQuery; }
/* harmony export */ });
/* unused harmony exports blogIndexQueryProduction, blogIndexQueryPreview, guidesIndexQueryProduction, guidesIndexQueryPreview, authorQuery, investorQuery, docQuery, pageQuery, siteSettingsQuery, blogSlugsQueryProduction, blogSlugsQueryPreview, blogBySlugQuery, tutorialSlugsQueryProduction, tutorialSlugsQueryPreview, tutorialBySlugQuery, marketingLPSlugsQuery, marketingLPBySlugQuery, docSlugsQuery, navigationQuery */
const blogFields = '\n  _id,\n  name,\n  title,\n  date,\n  excerpt,\n  coverImage,\n  category,\n  mdx,\n  live,\n  "slug": slug.current,\n  "author": author->{name, picture},\n  seo,\n  featured\n';
const tutorialFields = '\n_id,\nname,\ntitle,\nexcerpt,\ncoverImage,\ncategory,\nlive,\n"slug": slug.current,\n"author": author->{name, picture},\ntime,\nmarkdown,\nbody[] {\n  ...,\n  markDefs[]{\n    ...,\n    _type == "internalLink" => {\n      "slug": @.reference->slug\n    }\n  },\n  body[] {\n    ...,\n    markDefs[]{\n      ...,\n      _type == "internalLink" => {\n        "slug": @.reference->slug\n      }\n    }\n  },\n},\nseo\n';
const docFields = '\n  _id,\n  seo,\n  title,\n  subtitle,\n  body[] {\n    ...,\n    markDefs[]{\n      ...,\n      _type == "internalLink" => {\n        "slug": @.reference->slug\n      }\n    },\n    body[] {\n      ...,\n      markDefs[]{\n        ...,\n        _type == "internalLink" => {\n          "slug": @.reference->slug\n        }\n      }\n    },\n  },\n  "slug": slug.current\n';
const authorFields = "\n  _id,\n  name,\n  picture,\n  role,\n  socials,\n  teammate\n";
const investorFields = "\n  _id,\n  name,\n  picture,\n  role,\n  url\n";
const pageFields = '\n  _id,\n  seo,\n  pageText,\n  pageCode,\n  pageImage,\n  pageJSON,\n  body[]{\n    ...,\n    richText[]{\n      ...,\n      markDefs[]{\n        ...,\n        _type == "internalLink" => {\n          "slug": @.reference->slug\n        }\n      }\n    }\n  },\n  "slug": slug.current,\n';
const blogIndexQueryProduction = "\n*[_type == \"blog\" && live == true && !(_id in path('drafts.**'))] | order(date desc, _updatedAt desc) {\n  ".concat(blogFields, "\n}");
const blogIndexQueryPreview = "\n*[_type == \"blog\" && !(_id in path('drafts.**'))]  | order(date desc, _updatedAt desc) {\n  ".concat(blogFields, "\n}");
const guidesIndexQueryProduction = '\n*[(_type == \'tutorial\' || _type == "blog") && live == true && (category == "Guide" || category == "Tutorial") && !(_id in path(\'drafts.**\'))] | order(date desc, _updatedAt desc) {\n  '.concat(blogFields, "\n}");
const guidesIndexQueryPreview = '\n*[(_type == \'tutorial\' || _type == "blog") && (category == "Guide" || category == "Tutorial") && !(_id in path(\'drafts.**\'))] | order(date desc, _updatedAt desc) {\n  '.concat(blogFields, "\n}");
const authorQuery = '\n*[_type == "author"] | order(order asc) {\n  '.concat(authorFields, "\n}");
const investorQuery = '\n*[_type == "investor"] | order(order asc) {\n  '.concat(investorFields, "\n}");
const docQuery = '\n*[_type == "doc"] {\n    _id,\n  title,\n  "slug": slug.current\n}';
const blogQuery = '\n{\n  "blog": *[_type == "blog" && slug.current == $slug] | order(_updatedAt desc)[0]{\n    "body": body[]{\n      ...,\n      authors[]->,\n      markDefs[]{\n        ...,\n        _type == "internalLink" => {\n          "slug": @.reference->slug\n        }\n      },\n      body[] {\n        ...,\n        markDefs[]{\n          ...,\n          _type == "internalLink" => {\n            "slug": @.reference->slug\n          }\n        }\n      }\n},\n    '.concat(blogFields, '\n  },\n  "moreBlogs": *[_type == "blog" && slug.current != $slug] | order(date desc, _updatedAt desc)[0...2] {\n    "body": body[]{\n      ...,\n      authors[]->,\n},\n    ').concat(blogFields, "\n  }\n}");
const tutorialQuery = '\n{\n  "tutorial": *[_type == "tutorial" && slug.current == $slug] | order(_updatedAt desc)[0]{\n    "body": body[]{\n      ...,\n      authors[]->,\n},\n    '.concat(tutorialFields, '\n  },\n  "moreTutorials": *[_type == "tutorial" && slug.current != $slug] | order(date desc, _updatedAt desc)[0...2] {\n    "body": body[]{\n      ...,\n      authors[]->,\n},\n    ').concat(tutorialFields, "\n  }\n}");
const pageQuery = '\n{\n  "page": *[_type == "page" && slug.current == $slug] | order(_updatedAt desc)[0] {\n    content,\n    '.concat(pageFields, "\n  },\n}");
const siteSettingsQuery = '\n*[_type == "siteSettings"] | order(order asc)';
const blogSlugsQueryProduction = '\n*[_type == "blog" && live == true && defined(slug.current)][].slug.current\n';
const blogSlugsQueryPreview = '\n*[_type == "blog" && defined(slug.current)][].slug.current\n';
const blogBySlugQuery = '\n*[_type == "blog" && slug.current == $slug][0] {\n  '.concat(blogFields, "\n}\n");
const tutorialSlugsQueryProduction = '\n*[_type == "tutorial" && live == true && defined(slug.current)][].slug.current\n';
const tutorialSlugsQueryPreview = '\n*[_type == "tutorial" && defined(slug.current)][].slug.current\n';
const tutorialBySlugQuery = '\n*[_type == "tutorial" && slug.current == $slug][0] {\n  '.concat(tutorialFields, "\n}\n");
const marketingLPSlugsQuery = '\n*[_type == "marketing-lp" && defined(slug.current)][].slug.current\n';
const marketingLPBySlugQuery = '\n{\n  "page": *[_type == "marketing-lp" && slug.current == $slug][0] {\n    '.concat(pageFields, "\n  }\n}\n");
const docSlugsQuery = '\n*[_type == "doc" && defined(slug.current)][].slug.current\n';
const docBySlugQuery = '\n*[_type == "doc" && slug.current == $slug] | order(_updatedAt desc)[0] {\n  '.concat(docFields, "\n}\n");
const navigationQuery = '\n*[navId.current match "docs-*"] | order(order asc) {\n  name,\n "navId": navId.current,\n "categories": linkCategories[]{\n   "categoryId": categoryId.current,\n   categoryName,\n   links[] {\n     _key,\n     title,\n     "slug": internalLink->slug.current,\n     "url": externalLink.href,\n     "childLinks": links[]{\n       _key, \n       title, \n       "slug": internalLink->slug.current, \n       "url": externalLink.href\n     }\n   }\n }\n}\n';


/***/ }),

/***/ 68667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ BlogPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12918);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(28582);
/* harmony import */ var _lib_queries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87585);
/* harmony import */ var _lib_sanity__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53822);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97324);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(39309);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(50336);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(28032);
/* harmony import */ var _components_sanity_sane_block__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51061);
/* harmony import */ var _components_sanity_sane_image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27013);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(52494);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(94323);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72408);
/* harmony import */ var pages__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16263);















var __N_SSG = true;
function BlogPage(param) {
    let { data ={} , preview  } = param;
    var ref, ref1;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const slug = data === null || data === void 0 ? void 0 : (ref = data.blog) === null || ref === void 0 ? void 0 : ref.slug;
    const live = data === null || data === void 0 ? void 0 : (ref1 = data.blog) === null || ref1 === void 0 ? void 0 : ref1.live;
    const { data: { blog , suggested  }  } = (0,_lib_sanity__WEBPACK_IMPORTED_MODULE_4__/* .usePreviewSubscription */ .$r)(_lib_queries__WEBPACK_IMPORTED_MODULE_3__/* .blogQuery */ .Zk, {
        params: {
            slug
        },
        initialData: data,
        enabled: preview && slug
    });
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(()=>{
        pages__WEBPACK_IMPORTED_MODULE_9__.analytics.track("Marketing_Blog_".concat(data.blog.title, " Viewed"), {
            surface: "Marketing",
            location: "Blog Post"
        });
    }, []);
    if (!router.isFallback && !slug || utils__WEBPACK_IMPORTED_MODULE_10__/* .isProduction */ .yv && !live) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_error__WEBPACK_IMPORTED_MODULE_1__["default"], {
            statusCode: 404
        });
    }
    const formattedDate = (blog === null || blog === void 0 ? void 0 : blog.date) && (0,date_fns__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(new Date(blog.date), "MMM dd, yyyy");
    return router.isFallback ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Box */ .xu, {
        children: "Loading"
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Center */ .M5, {
                py: "60px",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Flex */ .kC, {
                    w: "full",
                    alignItems: "center",
                    justifyContent: "space-around",
                    pb: "24px",
                    pt: "56px",
                    maxW: "1420px",
                    display: {
                        base: "none",
                        lg: "inline-flex"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                            legacyBehavior: true,
                            href: "/blog",
                            passHref: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .HStack */ .Ug, {
                                as: "a",
                                color: "primary.500",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .Icon */ .JO, {
                                        as: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Text */ .xv, {
                                        children: "Back"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .HStack */ .Ug, {
                            gap: "16px",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Heading */ .X6, {
                                    as: "h4",
                                    size: "sm",
                                    color: "primary.500",
                                    bg: "primary.25",
                                    maxW: "fit-content",
                                    padding: "6px 12px",
                                    gap: "8px",
                                    borderRadius: "999px",
                                    children: blog.category
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Divider */ .iz, {
                                    h: "28px",
                                    orientation: "vertical"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Text */ .xv, {
                                    pl: "12px",
                                    textColor: "#626B7F",
                                    children: formattedDate
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Box */ .xu, {
                            w: "60px"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Box */ .xu, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_15__/* .Socials */ .I, {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Center */ .M5, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_16__/* .LayoutContainer */ .k, {
                    verticalPadding: "none",
                    maxW: "776px",
                    mb: "100px",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_17__/* .PreviewBadge */ .P, {
                            isLive: blog.live,
                            isTop: true
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Box */ .xu, {
                            display: {
                                base: "inline-flex",
                                lg: "none"
                            },
                            mt: 14,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                                legacyBehavior: true,
                                href: "/blog",
                                passHref: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .HStack */ .Ug, {
                                    as: "a",
                                    h: "56px",
                                    color: "primary.500",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .Icon */ .JO, {
                                            as: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Text */ .xv, {
                                            children: "Back"
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Flex */ .kC, {
                            w: "auto",
                            flexDir: "column",
                            justifyContent: "space-evenly",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .HStack */ .Ug, {
                                    py: "24px",
                                    gap: "16px",
                                    display: {
                                        base: "inline-flex",
                                        lg: "none"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Heading */ .X6, {
                                            as: "h4",
                                            size: "sm",
                                            color: "primary.500",
                                            bg: "primary.25",
                                            maxW: "fit-content",
                                            padding: "6px 12px",
                                            gap: "8px",
                                            borderRadius: "999px",
                                            children: blog.category
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Divider */ .iz, {
                                            h: "28px",
                                            orientation: "vertical"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Text */ .xv, {
                                            pl: "12px",
                                            textColor: "#626B7F",
                                            children: formattedDate
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Heading */ .X6, {
                                    lineHeight: "48px",
                                    mb: "24px",
                                    pt: "16px",
                                    children: blog.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Stack */ .Kq, {
                                    flexDir: {
                                        base: "column",
                                        lg: "row"
                                    },
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .HStack */ .Ug, {
                                            py: "24px",
                                            w: "100%",
                                            children: [
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_sanity_sane_image__WEBPACK_IMPORTED_MODULE_6__/* .SaneImage */ .Q, {
                                                    className: "block w-10 h-10 rounded-full",
                                                    alt: blog.author.name,
                                                    src: blog.author.picture,
                                                    height: 40,
                                                    width: 40,
                                                    quality: 100
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Text */ .xv, {
                                                    pl: "16px",
                                                    pr: "12px",
                                                    children: blog.author.name
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Divider */ .iz, {
                                            w: "100%",
                                            display: {
                                                base: "flex",
                                                lg: "none"
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Box */ .xu, {
                            pt: "32px",
                            pb: "48px",
                            display: {
                                base: "inline-flex",
                                lg: "none"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_15__/* .Socials */ .I, {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Center */ .M5, {
                            children: blog.coverImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_sanity_sane_image__WEBPACK_IMPORTED_MODULE_6__/* .SaneImage */ .Q, {
                                src: blog.coverImage
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Stack */ .Kq, {
                            marginTop: "24px",
                            fontSize: "18px",
                            lineHeight: "32px",
                            letterSpacing: "-0.02em",
                            children: blog.excerpt && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Text */ .xv, {
                                py: "32px",
                                children: blog.excerpt
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Divider */ .iz, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Stack */ .Kq, {
                            marginTop: "24px",
                            fontSize: "18px",
                            lineHeight: "32px",
                            letterSpacing: "-0.02em",
                            width: {
                                base: "90vw",
                                md: "100%"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_sanity_sane_block__WEBPACK_IMPORTED_MODULE_5__/* .SaneBlockChakra */ .C, {
                                blocks: blog.body
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_17__/* .PreviewBadge */ .P, {
                            isLive: blog.live
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 97324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "yv": function() { return /* binding */ isProduction; }
/* harmony export */ });
/* unused harmony exports isStaging, isDevelopment */
const currentRuntimeEnv = "preview";
const isStaging = currentRuntimeEnv === "preview";
const isProduction = currentRuntimeEnv === "production";
const isDevelopment = !isStaging && !isProduction;


/***/ }),

/***/ 12918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(97345)


/***/ }),

/***/ 94323:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function ChevronLeftIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z",
    clipRule: "evenodd"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (ChevronLeftIcon);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6241,9385,8582,1061,9774,2888,179], function() { return __webpack_exec__(41127); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);